import { MessengerV2 } from 'lib-shared-legacy-types';
import { useState } from 'react';
import { useEffectOnce } from 'react-use';

import { dixaMessengerApi } from 'assets/components/settings/components/sections/dixaMessenger/api/apiProvider';

export function useFetchMessengers(): MessengerV2[] | undefined {
  const [messengers, setMessengers] = useState<MessengerV2[]>();
  useEffectOnce(() => {
    dixaMessengerApi.fetchAll({ params: { limit: 1000 } }).then(({ data }) => {
      setMessengers(data.messengers);
    });
  });

  return messengers;
}
